import { render, staticRenderFns } from "./MyProjectsContractNotes.vue?vue&type=template&id=47a1b7a5&scoped=true"
import script from "./MyProjectsContractNotes.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsContractNotes.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectsContractNotes.vue?vue&type=style&index=0&id=47a1b7a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a1b7a5",
  null
  
)

export default component.exports